<ng-template #errorCampo let-ruta="ruta">
  <div class="cf-field__error" [class.m184d-aviso]="m.type === 'WARNING'" *ngIf="mensaje(ruta) as m">
    <mat-icon>{{ m.type === 'WARNING' ? 'warning' : 'error' }}</mat-icon> {{ m.message }}
  </div>
</ng-template>

<ng-template #texto let-ruta="ruta" let-etiqueta="etiqueta" let-requerido="requerido" let-max="max" let-span="span">
  <div class="m184d-field" [style.grid-column]="'span ' + (span || 3)" [class.cf-field--required]="requerido"
    [class.cf-field--invalid]="!!mensaje(ruta)">
    <app-ui-input [attr.id]="'miembros.' + ruta" [ngModel]="f[ruta]" (ngModelChange)="set(ruta, $event)"
      [config]="{ label: etiqueta, maxLength: max }"></app-ui-input>
    <ng-container *ngTemplateOutlet="errorCampo; context: { ruta: ruta }"></ng-container>
  </div>
</ng-template>

<ng-template #numero let-ruta="ruta" let-etiqueta="etiqueta" let-requerido="requerido" let-entero="entero" let-span="span">
  <div class="m184d-field" [style.grid-column]="'span ' + (span || 3)" [class.cf-field--required]="requerido"
    [class.cf-field--invalid]="!!mensaje(ruta)">
    <app-ui-input [attr.id]="'miembros.' + ruta" [ngModel]="f[ruta]" (ngModelChange)="set(ruta, $event)"
      [config]="{ label: etiqueta, type: 'number', step: entero ? '1' : '0.0001', inputmode: entero ? 'numeric' : 'decimal' }"></app-ui-input>
    <ng-container *ngTemplateOutlet="errorCampo; context: { ruta: ruta }"></ng-container>
  </div>
</ng-template>

<ng-template #seleccion let-ruta="ruta" let-etiqueta="etiqueta" let-opciones="opciones" let-requerido="requerido" let-span="span">
  <div class="m184d-field" [style.grid-column]="'span ' + (span || 3)" [class.cf-field--required]="requerido"
    [class.cf-field--invalid]="!!mensaje(ruta)">
    <app-select [attr.id]="'miembros.' + ruta" [ngModel]="f[ruta]" (ngModelChange)="set(ruta, $event)"
      [config]="{ label: etiqueta, options: opciones, placeholder: 'Seleccionar' }"></app-select>
    <ng-container *ngTemplateOutlet="errorCampo; context: { ruta: ruta }"></ng-container>
  </div>
</ng-template>

<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon">
      <mat-icon>groups</mat-icon>
    </div>
    <div class="m184d-header-text">
      <h2 class="cf-dlg-title">{{ titulo }}</h2>
      <p class="cf-dlg-subtitle">{{ subtitulo }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="cerrar()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="saving" message="Guardando el miembro…"></app-loading-state>

  <ng-container *ngIf="!saving">
    <div class="cf-dlg-body">

      <div class="m184d-alert m184d-alert--error" *ngIf="sueltas.length">
        <mat-icon>error</mat-icon>
        <div>
          <div *ngFor="let item of sueltas; trackBy: trackByIndex">{{ item.message }}</div>
        </div>
      </div>

      <fieldset class="m184d-fs">

        <div class="m184d-box">
          <h6 class="m184d-box__title">Datos del socio, heredero, comunero o partícipe</h6>
          <div class="m184d-grid">
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'nif', etiqueta: 'NIF', requerido: true, max: 9, span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'nifRepresentante', etiqueta: 'NIF del representante legal', max: 9, span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'nombre', etiqueta: 'Apellidos y nombre o razón social', requerido: true, span: 6 }"></ng-container>
            <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'tipoParticipe', etiqueta: 'Tipo de partícipe', opciones: tipoParticipeOptions, requerido: true, span: 6 }"></ng-container>
            <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'provincia', etiqueta: 'Provincia', opciones: provinciaOptions, span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'pais', etiqueta: 'Clave de país de residencia', max: 2, span: 3 }"></ng-container>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'domicilio', etiqueta: 'Domicilio fiscal', max: 40, span: 12 }"></ng-container>
          </div>
        </div>

        <div class="m184d-box">
          <h6 class="m184d-box__title">Participación en la entidad</h6>
          <div class="m184d-grid">
            <ng-container *ngTemplateOutlet="numero; context: { ruta: 'participacion', etiqueta: 'Porcentaje de participación', requerido: true, span: 4 }"></ng-container>
            <ng-container *ngTemplateOutlet="numero; context: { ruta: 'dias', etiqueta: 'Días como miembro', entero: true, requerido: true, span: 4 }"></ng-container>
            <div class="m184d-field" style="grid-column: span 4;">
              <app-select id="miembros.miembroA31" [ngModel]="f.miembroA31SN" (ngModelChange)="f.miembroA31SN = $event"
                [config]="{ label: 'Miembro a 31 de diciembre', options: sinoOptions }"></app-select>
            </div>
          </div>
        </div>

        <div class="m184d-box">
          <h6 class="m184d-box__title">Inmueble del que proceden los rendimientos</h6>
          <div class="m184d-grid">
            <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'naturalezaInmueble', etiqueta: 'Naturaleza del inmueble', opciones: naturalezaOptions, span: 4 }"></ng-container>
            <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'situacionInmueble', etiqueta: 'Situación del inmueble', opciones: situacionOptions, span: 8 }"></ng-container>
            <ng-container *ngTemplateOutlet="texto; context: { ruta: 'referenciaCatastral', etiqueta: 'Referencia catastral', max: 20, span: 4 }"></ng-container>
            <ng-container *ngTemplateOutlet="seleccion; context: { ruta: 'claveDeclarado', etiqueta: 'Titularidad del inmueble', opciones: claveDeclaradoOptions, span: 4 }"></ng-container>
            <ng-container *ngTemplateOutlet="numero; context: { ruta: 'porcentajeTitularidad', etiqueta: 'Porcentaje de titularidad', span: 2 }"></ng-container>
            <ng-container *ngTemplateOutlet="numero; context: { ruta: 'diasArrendamiento', etiqueta: 'Días de arrendamiento', entero: true, span: 2 }"></ng-container>
          </div>
        </div>

      </fieldset>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="cerrar()">Cancelar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="guardar()">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>
  </ng-container>
</div>
